<template>
  <section
    class="container mx-auto py-6 md:pb-10 md:pt-[100px] flex flex-col-reverse md:flex-row gap-4"
  >
    <template v-if="isLoading">
      <div class="flex flex-col gap-6 w-full md:w-1/2">
        <UtilsSkeletonLoading class="hidden md:block w-full h-24" />
        <UtilsSkeletonLoading class="w-full h-32 md:h-48" />
        <UtilsSkeletonLoading class="w-1/3 mx-auto md:mx-0 h-7 md:h-12" />
      </div>
      <div
        class="w-full md:w-1/2 grid grid-rows-4 md:grid-rows-5 grid-cols-2 gap-x-1 md:gap-x-4 gap-y-8"
      >
        <UtilsSkeletonLoading
          class="w-full h-24 md:h-36 row-start-1 row-span-2"
        />
        <UtilsSkeletonLoading
          class="w-full h-24 md:h-36 row-start-1 md:row-start-2 row-span-2"
        />
        <UtilsSkeletonLoading
          class="w-full h-24 md:h-36 row-start-3 row-span-2"
        />
        <UtilsSkeletonLoading
          class="w-full h-24 md:h-36 row-start-3 md:row-start-4 row-span-2"
        />
      </div>
      <div class="md:hidden flex flex-col gap-6 w-full md:w-1/2">
        <UtilsSkeletonLoading class="w-full h-12" />
      </div>
    </template>

    <template v-else>
      <div class="w-full md:w-1/2 flex flex-col px-4 md:px-0 mt-4 md:mt-0">
        <h2 class="hidden md:block section-heading mb-5 md:mb-12">
          {{ lifeAtSuitmedia.attributes?.title }}
        </h2>
        <p class="text-base mb-4 md:mb-8 text-bw-800">
          {{ lifeAtSuitmedia.attributes?.description }}
        </p>
        <NuxtLink
          to="/careers/culture"
          title="Culture"
          class="py-3 px-[10px] sm:px-4 sm:py-3 text-sm sm:text-base border border-[#FF6700] rounded-md text-[#FF6700] block w-max hover:bg-[#FF6700] hover:text-white mx-auto md:mx-0"
          >Life at Suitmedia</NuxtLink
        >
      </div>
      <div class="w-full md:w-1/2 flex">
        <NuxtImg
          format="webp"
          srcset=""
          height="507"
          loading="lazy"
          :src="lifeAtSuitmedia.attributes?.image_mobile?.data?.attributes?.url"
          :alt="lifeAtSuitmedia.attributes.title"
          :title="lifeAtSuitmedia.attributes.title"
          class="md:hidden w-full m-auto"
        />
        <NuxtImg
          format="webp"
          srcset=""
          loading="lazy"
          height="507"
          :src="
            lifeAtSuitmedia.attributes?.image?.data?.[0]?.attributes?.formats
              ?.medium?.url
          "
          :alt="lifeAtSuitmedia.attributes.title"
          :title="lifeAtSuitmedia.attributes.title"
          class="hidden md:block w-full m-auto"
        />
      </div>

      <!-- Old Layout -->
      <!-- <div
      class="w-full md:w-1/2 grid grid-rows-4 md:grid-rows-5 grid-cols-2 gap-x-1 md:gap-x-4 gap-y-8"
    >
      <div class="row-start-1 row-span-2 flex flex-col">
        <NuxtImg format="webp" srcset="" loading="lazy" src="/assets/img/meet.png" class="mx-auto rounded-md w-4/5" />
        <p
          class="text-[10px] leading-4 md:text-lg text-bw-800 text-center p-2 md:py-2 md:px-4 life-text z-[1]"
        >
          Learning while Working
        </p>
      </div>
      <div class="row-start-1 md:row-start-2 row-span-2 flex flex-col">
        <NuxtImg format="webp" srcset="" loading="lazy" src="/assets/img/fun.png" class="mx-auto rounded-md w-4/5" />
        <p
          class="text-[10px] leading-4 md:text-lg text-bw-800 text-center p-2 md:py-2 md:px-4 life-text z-[1]"
        >
          Spirit of Fun
        </p>
      </div>
      <div class="row-start-3 row-span-2 flex flex-col">
        <NuxtImg format="webp" srcset="" loading="lazy" src="/assets/img/wlb.png" class="mx-auto rounded-md w-4/5" />
        <p
          class="text-[10px] leading-4 md:text-lg text-bw-800 text-center p-2 md:py-2 md:px-4 life-text z-[1]"
        >
          Work Life Balance
        </p>
      </div>
      <div class="row-start-3 md:row-start-4 row-span-2 flex flex-col">
        <NuxtImg format="webp" srcset="" loading="lazy"
          src="/assets/img/flexible.png"
          class="mx-auto rounded-md w-4/5"
        />
        <p
          class="text-[10px] leading-4 md:text-lg text-bw-800 text-center p-2 md:py-2 md:px-4 life-text z-[1]"
        >
          Flexibility at Work
        </p>
      </div>
    </div> -->
      <h2
        class="md:hidden text-center text-[22px] leading-normal sm:text-[40px] sm:leading-[50px] font-medium mb-2 text-bw-900"
      >
        {{ lifeAtSuitmedia.attributes?.title }}
      </h2>
    </template>
  </section>
</template>

<script setup>
const isLoading = ref(true)

const lifeAtSuitmedia = ref([])

const getLifeAtSuitmedia = async () => {
  const { data, error, pending } = await useSuitmediaApiData(
    `/api/life-at-suitmedia-career`,
    {
      query: {
        'fields[0]': 'id',
        'fields[1]': 'title',
        'fields[2]': 'description',
        populate: 'image, image_mobile'
      },
      retry: 3,
      retryDelay: 300
    },
    `life-at-suitmedia-career`
  )

  isLoading.value = pending.value

  if (error.value) {
    throw createError({
      statusCode: 404,
      message: `Our People does not exist`
    })
  }

  return data.value
}

const lifeAtSM = await getLifeAtSuitmedia()
lifeAtSuitmedia.value = lifeAtSM.data
</script>

<style lang="scss" scoped>
.life-text {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.08);

  width: max-content;
  margin-left: auto;
  margin-right: auto;
  margin-top: -20px;
}
</style>
